import { render, staticRenderFns } from "./CustomerHeaderInfo.vue?vue&type=template&id=42e2ad6c&scoped=true&"
import script from "./CustomerHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerHeaderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2ad6c",
  null
  
)

export default component.exports